<template>
  <span class="user-profile">
    <img :src="profileImage" loading="lazy" v-if="props.hasImage" />
    <span class="initials" v-else>{{ getInitials(props.username) }}</span>
  </span>
  <span data-cy="selected-user-name-txt" v-tooltip.ellipsis.mouse="username">
    {{ username }}
  </span>
</template>
<script setup lang="ts">
import store from "@/store";
import endpoints from "@services/endpoints";
import { getInitials } from "@util/user";
import { computed } from "vue";
import { useState } from "vuex-composition-helpers";
import { RootState } from "@medapro-types/common/rootstate";

const { auth } = useState<RootState>(["auth"]);

const props = defineProps<{
  id: string;
  username?: string;
  department?: string;
  hasImage?: boolean;
}>();

const profileImage = computed(() => {
  if (!props.id) {
    return "";
  }
  return store.state.meta.config.apiUrl + endpoints.user.profile.getProfileImage + `?raw=true&userId=${props.id}&key=${auth.value.token}`;
});

const username = computed(() => {
  return props.department ? `${props.username} (${props.department})` : props.username;
});
</script>
